export default __webpack_public_path__ + "static/media/speedcurve.b512e992.svg";